module.exports = __webpack_public_path__ + "images/vip-logo.png";